module.exports = __webpack_public_path__ + "img/fashion.f2cdf8de.svg";